import { Link } from "react-router-dom";
import { MapPin, BedDouble, Sparkles, UtensilsCrossed, ArrowRight, Star, Award } from "lucide-react";
import { BudgetBar } from "@/components/BudgetBar";
import { TransportCompare } from "@/components/TransportCompare";
import { imageFor, isDayTrip } from "@/lib/api";

const Row = ({ icon: Icon, label, value, sub }) => (
  <div className="flex gap-3">
    <Icon className="w-4 h-4 mt-0.5 text-amber-600 shrink-0" />
    <div className="min-w-0">
      <p className="text-[11px] font-mono uppercase tracking-widest text-gray-400">{label}</p>
      <p className="text-sm font-medium text-gray-900 truncate">{value}</p>
      {sub ? <p className="text-xs text-gray-500">{sub}</p> : null}
    </div>
  </div>
);

export const EscapadeCard = ({ e, index }) => (
  <article data-testid={`escapade-card-${index + 1}`} className={`rise d${index + 1} group flex flex-col rounded-2xl bg-white border border-gray-200 overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300`}>
    <div className="relative h-44 overflow-hidden">
      <img src={imageFor(e)} alt={e.destination} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B131E]/85 to-transparent" />
      <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-amber-100 text-amber-900 text-[11px] font-semibold capitalize">{e.angle}</span>
      {e.best_value ? (
        <span data-testid={`escapade-card-${index + 1}-best-value-badge`} className="absolute top-3 right-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-emerald-600 text-white text-[11px] font-semibold shadow">
          <Award className="w-3.5 h-3.5" />Meilleur rapport budget / plaisir
        </span>
      ) : null}
      <div className="absolute bottom-3 left-4 right-4 text-white">
        <p className="flex items-center gap-1 text-xs text-gray-200"><MapPin className="w-3.5 h-3.5" />{e.destination} · {e.distance_km} km</p>
        <h3 data-testid={`escapade-card-${index + 1}-title`} className="font-serif text-xl font-semibold leading-snug">{e.title}</h3>
      </div>
    </div>
    <div className="flex-1 flex flex-col p-6 gap-5">
      <BudgetBar budget={e.budget} userBudget={e.user_budget} compact testid={`escapade-card-${index + 1}-budget`} />
      <TransportCompare transport={e.transport} testid={`escapade-card-${index + 1}-transport`} />
      <div className="space-y-3">
        {isDayTrip(e) ? (
          <Row icon={BedDouble} label="Hébergement" value="Aller-retour dans la journée" sub="Pas de nuitée à prévoir" />
        ) : (
          <Row icon={BedDouble} label="Hébergement" value={e.accommodation?.name} sub={<span className="inline-flex items-center gap-1">{e.accommodation?.type} · <Star className="w-3 h-3 fill-amber-500 text-amber-500" />{e.accommodation?.rating}</span>} />
        )}
        <Row icon={Sparkles} label="Activité" value={e.main_activity?.name} />
        <Row icon={UtensilsCrossed} label="Restauration" value={e.restaurant?.name} sub={`${e.restaurant?.cuisine} · ${e.restaurant?.price_range}`} />
      </div>
      <p className="text-xs text-emerald-800 bg-emerald-50 rounded-lg p-3 leading-relaxed">{e.zone_coherence}</p>
      <Link to={`/escapade/${e.id}`} data-testid={`escapade-card-${index + 1}-view-btn`}
        className="mt-auto inline-flex items-center justify-center gap-2 h-11 rounded-full bg-[#0B131E] text-white text-sm font-semibold hover:bg-amber-600 transition-colors">
        Voir cette escapade <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
  </article>
);
